import { DateObject } from 'react-multi-date-picker';

interface IformatDate {
  day: number;
  month: number;
  year: number;
}

export const formatDate = ({ day, month, year }: IformatDate): string => {
  try {
    const formatted = new DateObject({ day, month, year }).format('MMM DD, YYYY');
    return formatted;
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};
